import axios from 'axios';

async function createBill(companyId, data) {
  const response = await axios.post(`/companies/${companyId}/bills`, data);

  return response.data;
}

async function listBills(companyId) {
  const response = await axios.get(`/companies/${companyId}/bills`);

  return response.data;
}

async function exportBills(companyId, format, data) {
  const response = await axios({
    url: `/companies/${companyId}/bills/export?format=${format}`,
    method: 'POST',
    responseType: format === 'pdf' ? 'blob' : 'text',
    data
  });

  return response.data;
}

const billService = {
  createBill,
  exportBills,
  listBills,
}

export default billService;
